module.exports = "<div id=\"frc-session\">\n    <div class=\"modal-header\">\n      <h4 class=\"modal-title\">Important</h4>\n    </div>\n    <div class=\"modal-body\">\n      <p> Password is changed successfully</p>\n    </div>\n    <div class=\"modal-footer\">\n      <button type=\"submit\" (click)=\"closeModal()\" class=\"save-btn btn btn-default\">Okay</button>\n    </div>\n  </div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/password-successful/password-successful.component.html
// module id = ./src/app/password-successful/password-successful.component.html
// module chunks = main